import classnames from 'classnames';
import { FC, useContext } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';

interface DownloadButtonProps {
  onDownload: () => void;
  isReversed?: boolean;
  label?: string;
  className?: string;
  tabIndex?: number;
}

export const DownloadButton: FC<DownloadButtonProps> = ({ onDownload: onclick, label, className, tabIndex }) => {
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);
  return (
    <button
      type="button"
      className={classnames('btn btn-flat-secondary', className)}
      data-e2e="download-csv-button"
      onClick={() => {
        logAnalytics.trackEvent(logAnalyticsCategory, 'Download schedule');
        onclick();
      }}
      tabIndex={tabIndex}
    >
      {label && <span>{label}</span>}
      <i className={classnames('icon', { 'ms-2': label })}>save_alt</i>
    </button>
  );
};
